import { FC, useMemo } from 'react'
import styles from 'components/features/external/PublicSpendingTrend/LineChartHover.styl'
import { AXIS_WIDTH } from 'components/features/external/PublicSpendingTrend/constants'
import { drawLine, Point } from 'components/features/external/PublicSpendingTrend/helpers'


type LineChartHoverProps = {
  points: Point[]
  index: number
  height: number
  width: number
}

export const LineChartHover: FC<LineChartHoverProps> = (props) => {
  const {
    points,
    index,
    height,
    width,
  } = props

  return useMemo(() => {
    if (index === -1) {
      return <></>
    }

    const sectionWidth = (width - AXIS_WIDTH) / (points.length - 1)
    const left = index * sectionWidth
    const point = points[index]

    if (!point) {
      return <></>
    }

    const line: Point[] = [
      [left + AXIS_WIDTH / 2, point[1]],
      [left + AXIS_WIDTH / 2, height],
    ]
    const path = drawLine(line)

    return (
      <path
        className={ styles.lineChartHover }
        d={ path }
      />
    )
  }, [width, index, points, height])

}
